import api from "./api";

const notificationService = {
  getNotifications: (params) => api.get("/notifications", { params }),

  /** Super admin only: fetch all notifications (global, institute, department, class, leave, edit profile) */
  getAllNotifications: (params) => api.get("/notifications/all", { params }),

  getGlobalNotifications: (params) => api.get("/notifications/global", { params }),

  getClassNotifications: (params) => api.get("/notifications/class", { params }),

  /** Classes the current user may send notifications to (scoped, no class.read needed). */
  getNotificationClasses: () => api.get("/notifications/classes"),

  createNotification: (notificationData) =>
    api.post("/notifications", notificationData),

  createGlobalNotification: (notificationData) =>
    api.post("/notifications/global", notificationData),

  createClassNotification: (classId, notificationData) =>
    api.post(`/notifications/class/${classId}`, notificationData),

  /** Send to one, many, or all classes (POST /notifications/class). */
  createClassNotificationsBulk: (notificationData) =>
    api.post("/notifications/class", notificationData),

  createDepartmentNotification: (departmentId, notificationData) =>
    api.post(`/notifications/department/${departmentId}`, notificationData),

  createInstituteNotification: (instituteId, notificationData) =>
    api.post(`/notifications/institute/${instituteId}`, notificationData),

  markAsRead: (notificationId) =>
    api.put(`/notifications/${notificationId}/read`),

  markAllAsRead: () => api.put("/notifications/read-all"),

  updateNotification: (notificationId, data) =>
    api.put(`/notifications/${notificationId}`, data),

  deleteNotification: (notificationId) =>
    api.delete(`/notifications/${notificationId}`),

  getUnreadCount: () => api.get("/notifications/unread-count"),
};

export default notificationService;
